// AONIC: Defer autoplay video loading until near viewport
(function() {
  function deferAutoplayVideos() {
    var deferredMediaEls = document.querySelectorAll('deferred-media[autoplay]');
    if (!deferredMediaEls.length) return;

    // Use 400px rootMargin so videos start loading before they enter viewport
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          observer.unobserve(el);

          // Try Horizon's native method first
          if (typeof el.showDeferredMedia === 'function') {
            el.showDeferredMedia();
            return;
          }

          // Fallback: clone template content into the element
          var template = el.querySelector('template');
          if (template) {
            var clone = template.content.cloneNode(true);
            el.appendChild(clone);
          }

          // Restore any stripped sources and call load()
          var videos = el.querySelectorAll('video');
          videos.forEach(function(v) {
            var sources = v.querySelectorAll('source');
            var restored = false;
            sources.forEach(function(s) {
              if (s.dataset.src) {
                s.src = s.dataset.src;
                delete s.dataset.src;
                restored = true;
              }
            });
            if (restored) v.load();
            // Attempt autoplay
            var playPromise = v.play();
            if (playPromise !== undefined) {
              playPromise.catch(function() {
                // Autoplay blocked — mute and retry (common on mobile)
                v.muted = true;
                v.play().catch(function() {});
              });
            }
          });
        }
      });
    }, { rootMargin: '400px 0px', threshold: 0 });

    deferredMediaEls.forEach(function(el) {
      // Remove eagerly loaded video src to prevent immediate download
      var videos = el.querySelectorAll('video:not(template video)');
      videos.forEach(function(v) {
        v.pause();
        var sources = v.querySelectorAll('source');
        sources.forEach(function(s) {
          if (s.src) {
            s.dataset.src = s.src;
            s.removeAttribute('src');
          }
        });
        v.load(); // abort current load
      });
      observer.observe(el);
    });
  }

  // Also handle non-autoplay videos: ensure they get loading="lazy"
  function lazyLoadVideos() {
    // Non-deferred videos that are off-screen — strip src until near viewport
    var nonDeferredVideos = document.querySelectorAll('video:not(deferred-media video)');
    if (!nonDeferredVideos.length) return;
    var vidObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var v = entry.target;
          vidObserver.unobserve(v);
          var sources = v.querySelectorAll('source');
          sources.forEach(function(s) {
            if (s.dataset.src) {
              s.src = s.dataset.src;
              delete s.dataset.src;
            }
          });
          v.load();
        }
      });
    }, { rootMargin: '300px 0px', threshold: 0 });

    nonDeferredVideos.forEach(function(v) {
      // Only defer videos that are not in the initial viewport
      var rect = v.getBoundingClientRect();
      if (rect.top > window.innerHeight) {
        var sources = v.querySelectorAll('source');
        sources.forEach(function(s) {
          if (s.src) {
            s.dataset.src = s.src;
            s.removeAttribute('src');
          }
        });
        v.load();
        vidObserver.observe(v);
      }
    });
  }

  function init() {
    deferAutoplayVideos();
    lazyLoadVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after section loads (e.g. quick-view, dynamic sections)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('theme:section:load', init);
})();
